<template>
  <div class="no-data-wrapper">{{ text }}</div>
</template>
<script>

export default {
  name: 'NoResults',
  props: {
    text: {
      type: String,
      default: ''
    }
  }
}
</script>

<style scoped>
.no-data-wrapper {
  font-style: normal;
  font-weight: normal;
  font-size: 17px;
  line-height: 27px;
  color: #5f6368;
  text-align: center;
  padding: 15px;
}
</style>
